import {Component, OnInit} from '@angular/core';
import {routerTransition} from '@app/router.animations';
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService} from '@app/shared/services';
import moment from 'moment';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {Nl2BrPipe} from '@app/shared/pipe';
import {PaginationComponent} from '@app/components/pagination/pagination.component';

@Component({
  selector: 'app-notes',
  templateUrl: './notes.component.html',
  styleUrls: ['./notes.component.scss'],
  animations: [routerTransition()],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    Nl2BrPipe,
    PaginationComponent
  ]
})
export class NotesComponent implements OnInit {

  public now = new Date();
  public date: any;
  public user_rights: any = {};
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  public user_data: any = {};
  public notes_data: any =
    {
      title: '',
      description: '',
      user_id: '',
      notes_id: 0,
    }

  index: any;
  public notes_list: any = [];
  status: any;
  public fileName: any = '';
  public image: any = "";
  search_text = '';
  state_data: any;

  state_options: any;

  constructor(private loaderService: LoaderService, public consultingService: ConsultingService, private toastr: ToastrService) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.notes_data.user_id = this.user_data.user_id;
    this.formatDateTime();
    this.getnotesList();
  }

  public savenotes(): any {
    if (this.notes_data.title == "") {
      this.toastr.error( 'Please enter the title!');
      return false;
    }
    if (this.notes_data.description == '') {
      this.toastr.error( 'Please enter the description!');
      return false;
    }

    const postData = {
      user_id: this.user_data.user_id,
      title: this.notes_data.title,
      description: this.notes_data.description,
      notes_id: this.notes_data.notes_id,
    }
    this.loaderService.display(true);
    this.consultingService.saveNotes(postData).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.loaderService.display(false);
        this.toastr.success( result.msg);
        this.getnotesList();
        this.notes_data =
          {
            title: '',
            description: '',
            user_id: '',
            notes_id: 0,
          }

      } else {
        this.toastr.error( result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public keyDownFunction(event: any) {
    if (event.keyCode == 13) {
      this.getsearchlist();
    }
  }

  public getnotesList(page = 0) {
    const limit = 50;
    this.start = page * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      user_id: this.user_data.user_id
    };
    this.loaderService.display(true);
    this.loaderService.display(true);
    this.consultingService.listNotes(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.notes_list = result['data'];

        this.collection = result['total_count'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
      }
    });
  }

  public clear_search() {

    if (this.search_text != '') {
      this.search_text = ''
      this.getnotesList();
    }
  }

  getsearchlist() {
    const limit = 50;
    this.start = 0;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.search_text,
      user_id: this.user_data.user_id
    };
    this.loaderService.display(true);
    this.loaderService.display(true);
    this.consultingService.listNotes(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.notes_list = result['data'];
        this.collection = result['total_count'];
        const i = this.notes_list.length;
        this.index = i + 5;
        this.status = result['status'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
        this.status = result['status'];
      }
    });
  }

  public editnotes(note: any) {
    this.notes_data.title = note.TITLE;
    this.notes_data.description = note.DESCRIPTION;
    this.notes_data.notes_id = note.NOTES_ID;
    window.scrollTo(0, 0);
  }

  public formatDateTime() {
    if (this.now) {
      this.date = moment(this.now, 'yyyy-MM-D HH:mm.ss a').format('D-MM-Y h:mm a');
    }
  }

  protected clearnotes() {

  }
}
